var map = {
	"./article.svg": 38762,
	"./back.svg": 76605,
	"./books.svg": 93066,
	"./calendar.svg": 87734,
	"./check.svg": 876,
	"./check_green.svg": 23688,
	"./check_white.svg": 56182,
	"./chevron-right.svg": 26412,
	"./children.svg": 88001,
	"./clipboard.svg": 47390,
	"./closed.svg": 12884,
	"./dots.svg": 52680,
	"./down-arrow.svg": 9924,
	"./empty-mail-box.svg": 89489,
	"./facebook-logo-outline.svg": 48401,
	"./form-error.svg": 36355,
	"./globe-color.svg": 59361,
	"./globe.svg": 5235,
	"./hamburger.svg": 98625,
	"./headphones.svg": 47037,
	"./heart.svg": 53032,
	"./heart2.svg": 87050,
	"./hearts.svg": 48091,
	"./invisible.svg": 21581,
	"./invitation.svg": 31737,
	"./learning.svg": 99858,
	"./link-chain.svg": 47104,
	"./lock.svg": 53225,
	"./login-family.svg": 30660,
	"./login-school.svg": 35376,
	"./logout.svg": 77046,
	"./mail-letter.svg": 58586,
	"./mail_icon.svg": 71063,
	"./maximize.svg": 7794,
	"./medal.svg": 90741,
	"./minimize.svg": 9588,
	"./more.svg": 72615,
	"./news.svg": 51169,
	"./pause.svg": 13834,
	"./pen.svg": 51325,
	"./play-button.svg": 89415,
	"./qr-code.svg": 91073,
	"./resend.svg": 68605,
	"./setting.svg": 61312,
	"./spinner-blue.svg": 22496,
	"./spinner-red.svg": 12169,
	"./spinner.svg": 10339,
	"./star.svg": 87884,
	"./stripe-black.svg": 46673,
	"./subscription.svg": 23367,
	"./teach.svg": 97939,
	"./user.svg": 3189,
	"./visible.svg": 21378,
	"./voucher.svg": 32974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46256;